/** Textos da seção "Papéis Obrigatórios" (Nova Obra, etapa Equipe, e Definir Equipe de Obra). */

export const PAPEIS_OBRIGATORIOS_TITLE = "Papéis Obrigatórios";
export const PAPEIS_OBRIGATORIOS_HINT =
  "Os papéis obrigatórios devem ser adicionados até a data limite, ou será gerado uma pendência.";
export const PAPEIS_OBRIGATORIOS_EMPTY = "Nenhum papel obrigatório configurado.";
export const PAPEIS_OBRIGATORIOS_ADD_LABEL = "Adicionar";
export const PAPEIS_OBRIGATORIOS_ADDED_LABEL = "Adicionado";
